// extracted by mini-css-extract-plugin
export var active = "_ck-c";
export var compactArrow = "_ck-5";
export var container = "_ck-0";
export var dot = "_ck-b";
export var dotContainer = "_ck-a";
export var hoverArrowButton = "_ck-7";
export var hoverArrowContainer = "_ck-6";
export var leftHoverArrowContainer = "_ck-8 _ck-6";
export var rightHoverArrowContainer = "_ck-9 _ck-6";
export var slide = "_ck-4";
export var sliderContainer = "_ck-1";
export var sliderContainerVisibleOverflow = "_ck-2";
export var sliderOverflow = "_ck-3";
export var vignetteBoth = "_ck-f";
export var vignetteLeft = "_ck-e";
export var vignetteRight = "_ck-d";